import { EventArgs } from "./..";
import { toJSON } from "../data/JSON";
export class ObservableCollectionEntryEventArgs extends EventArgs {
  get entry() {
    return this._entry;
  }

  get propertyObserved() {
    return this._propertyObserved;
  }

  constructor(_entry, _propertyObserved) {
    super();
    this._entry = _entry;
    this._propertyObserved = _propertyObserved;
    this.toJSON = void 0;
    this.toJSON = toJSON;
  }

}
